import * as React from 'react'

const PostMetadata = () => {
   return (
      <div className="container bg-[#f5f5f5] my-0 mx-auto mb-[30px] border-t border-t-[#ccc] border-b border-b-[#ccc] p-[15px] min-[360px]:p-[15px_20px]">
         <div className="flex justify-between items-center leading-normal max-w-[650px] mx-auto mb-[25px]">
            <div className="text-left font-normal text-[#444] flex items-center text-[12px] min-[360px]:text-[13px] [&_b]:ml-[1px]">
               <figure className="w-[55px] h-[55px] rounded-[30px] border border-[#999] overflow-hidden mr-[12px] my-0 [&_img]:w-[55px] [&_img]:h-[55px]">
                  <img src="/img/mike-grey.jpg" alt="Mike" />
               </figure>
               <span>
                  Written by <b>Mike</b>
                  <br />
               </span>
            </div>
         </div>
      </div>
   )
}

export default PostMetadata
